import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import componentStyles from './pc-base-layout.css.lit';

/**
 * Base layout two column component
 * @element pc-base-layout
 * @slot - This element has a left slot
 * @slot - This element has a right slot
 */
@customElement('pc-base-layout')
export class PCBaseLayout extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  render(): TemplateResult {
    return html`
      <div class="container">
        <div class="left-side">
          <slot name="left"></slot>
        </div>
        <div class="right-side">
          <slot name="right"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-base-layout': PCBaseLayout;
  }
}
